import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { ResourceService } from '@smartsoftware/reflex-core';
import { SyncVendorEntity } from '../models';

@Injectable()
export class SyncVendorEntity_Service extends ResourceService<SyncVendorEntity> {
    protected servicePath: string = '/SyncVendorEntity';

    public ModelType = SyncVendorEntity;

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }
}
